module.exports = __webpack_public_path__ + "media/about/max-schmidt-6eec3114.jpg";